import { Empty } from "antd";
import GovernmentCard from "../gepeg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PaginationComponent from "../../paginationComponet";

export default function GEPGHistoryGrid({ dataSource = [] }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(dataSource.slice(0, 10));
  }, [dataSource]);

  const handlePageChange = (currentPage, slicedData) => {
    setData(slicedData);
  };
  return (
    <>
      <div className="row px-2">
        {dataSource.length === 0 ? (
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        ) : (
          <div className="ft-table">
            <table className="table" style={{ cursor: "pointer" }}>
              <thead style={{ backgroundColor: "#F1F1F1" }}>
                <tr>
                  <th>
                    {t("common.account_no_lbl", {
                      defaultValue: "Account Number",
                    })}
                  </th>
                  <th>
                    {t("pages.gepeg.paid_amount", {
                      defaultValue: "Paid Amount",
                    })}
                  </th>
                  <th>
                    {" "}
                    {t("pages.pending_approval.control_number", {
                      defaultValue: "Control Number",
                    })}
                  </th>
                  <th>
                    {t("pages.pending_approval.Initiated_Date", {
                      defaultValue: "Initiated Date",
                    })}
                  </th>
                  <th>{t("common.status", { defaultValue: "Status" })}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((option, index) => (
                  <GovernmentCard record={option} />
                ))}
              </tbody>
              <tfoot>
              <tr>
                <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                    )}
                </td>
              </tr>
            </tfoot>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
